import basePath from "../path";

export default `${basePath}/sales-navigator/companies`;
